import React, { useCallback, useEffect } from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import HC_anotations from 'highcharts/modules/annotations'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";

require("highcharts/modules/export-data")(Highcharts);
HC_anotations(Highcharts)
HC_exporting(Highcharts)
Theme(Highcharts)

const LineChartAR:  any = (props:any) => {
    //console.log(props);
    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData, exportExcel, labels,subtitle='', title, idChart, activeButton, dataDefault, onChangeSelect, colores,nombresLabel=['Plebiscito de salida 1','Plebiscito de salida 2'],anotationActive=true} = props;
	//console.log(`TITULO ::: ${title}`)
	// console.log(allData)
	
	const options = {
		chart: {
            type: 'spline',
            zoomType: 'x',
            panning: true,
            backgroundColor: '#ffffff',
            panKey: 'shift',
            height:500,
            scrollablePlotArea: {
                minWidth:  500
            }
        },

		title: {
			text: title,
            style: {
				color: '#19355F',
				fontFamily: 'Montserrat-SemiBold'
            }
				
		},
		subtitle: {
			text: subtitle
		},
		xAxis: {
            gridLineWidth: 0,
            categories: labels,
            minRange: 10,
        },
		yAxis: {
			max:100,
			title: "enabled",
            minorGridLineWidth: 0,
			gridLineWidth: 0,
			
			
            labels:{
				format: '{value}%'
			},
            
        },
		legend: {

			backgroundColor: '#FFFFFF',
			itemStyle: {
				color: '#19355F',
				fontFamily: 'Montserrat',
				fontSize: '11px',
				fontWeight: 'normal',
				padding: '10',
				symbolRadius: 6,
				symbolWidth: 22,
				symbolPadding: 10,
				
			}
		},
		
		// xAxis: {
		// 	tickInterval: 1,
		// 	labels: {
		// 		enabled: true,
		// 		// formatter: function() { 
		// 		// 	// console.log(allData)
		// 		// 	console.log(this)
		// 		// 	// return allData[series.name][0];
		// 		// },
		// 	}
		// },
		//@ts-ignore
		annotations: anotationActive?[{
			draggable: '',

			labels: [{
				point: {
					xAxis: 0,
					yAxis: 0,
					x: 0,
					y: 56
				},
				text: nombresLabel[0],

			},{
				point: {
					xAxis: 0,
					yAxis: 0,
					x: 30,
					y: 44
				},
				text: nombresLabel[1]
			}]
		}]:[],
		// xAxis: {
		// 	categories : ["Enero S3",
        //     "Febrero S2",
        //     "Febrero S4",
        //     "Marzo s1",
        //     "Marzo s2"],
		// },
	
		plotOptions: {
			series: {
				dataLabels: {
				align: 'right',
				enabled: true,
				inside: false
				},
				grouping: true
			}
		},

		tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
			pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
				'<td style="text-align: right"><b>{point.y}%</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: 0
		},
	

		series: allData,
		colors: colores,

		responsive: {  
			rules: [{  
				condition: {  
				maxWidth: 700
				},  
				chartOptions: {
					title: {		
						style: {
							fontFamily: 'Sans-Serif',
							fontSize: '14px',
	
						}
					},
					xAxis:{
						labels:{
							style:{
								fontSize: '10px',
							}
						}
	
					},
					yAxis:{
						labels:{
							style:{
								fontSize: '10px',
							}
						}
	
					},
					legend: {

						backgroundColor: '#FFFFFF',
						itemStyle: {
							color: '#19355F',
							fontFamily: 'Montserrat',
							fontSize: '11px',
							fontWeight: 'normal',
							padding: '10',
							symbolRadius: 6,
							symbolWidth: 22,
							symbolPadding: 10,
							
						}
					},
					subtitle: {
						style: {
							color: '#19355F',
							fontFamily: 'Montserrat',
							width: '80%',
							wordBreak: 'break-word',
							fontSize: '10px',
	
						}
						
					},
				credits: {
					enabled: false
				}
			}
			}]  
			},
		
			lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
			},

			exporting: {
			enabled: true, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						//console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				}
			},
			
			buttons: {
				contextButton: {
					menuItems: [
						"viewFullscreen",
						"printChart",
						"separator",
						"downloadPNG",
						"downloadJPEG",
						"downloadPDF",
						"downloadSVG",
						"separator",
						"label"
					]
				}
			}
		},
		credits: {
			enabled: false
		}

	}
	// useEffect(() => {
	// 	console.log("Paso")
	// 	// console.log(allData)
	// 	// console.log(dataDefault)
	// 	if ( allData[0]['label'] ==  '' ) {
	// 		if ( dataDefault.length === 2 ){
	// 			onChangeSelect(dataDefault);
	// 		}
	// 	} 
	// }, [dataDefault])

	return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default LineChartAR;